import * as React from "react";

import { Layout } from "react-admin";

import { AppBar } from "../app-bar/AppBar";

export const AppLayout: React.FC = (props: any) => <Layout {...props} appBar={AppBar}/>;
